import admin from '../views/Admin/routes'
import login from '../views/Login/routes'

export default [
  ...login,
  ...admin,
  { path: '*', redirect: '/' }
]
